import React from 'react';
import { RestorativeOptions } from '../type';
import { useLang } from '../../../../util/lang';
import { BASE_PRESCRIPTION_NOTES_LANG_KEY } from './RestorativeOptions';
import TeethDisplaySummary from '../TeethDisplaySummary/TeethDisplaySummary';
import useDisplayRestorativeOptionValue from '../../../../hooks/useDisplayRestorativeOptionValue';
/**
 * RestorativeOptionsSummary component displays a summary of restorative treatment options
 * Shows the selected restorative options including sub-options and vertical dimension settings
 * @param {Object} props - Component props
 * @param {string | JSX.Element} [props.label=''] - Display label for the summary section
 * @param {RestorativeOptions} props.restorativeOptions - The restorative options configuration object
 * @param {Object} props.teeth - Teeth object for UI display
 * @returns {JSX.Element} Summary display of restorative options
 */
function RestorativeOptionsSummary({ label, restorativeOptions, teeth }) {
    const getNotes = useLang(`NewPatient`);
    const getLang = useLang();
    const { verticalDimensionUpperPosterior, verticalDimensionLowerPosterior } =
        restorativeOptions.subValue.verticalDimension;
    const { getValueDisplay } = useDisplayRestorativeOptionValue();

    return (
        <>
            {label}
            <p>{restorativeOptions?.value === 'Yes' ? getLang('@global.const.yes') : getLang('@global.const.no')}</p>
            {restorativeOptions?.value === 'Yes' && (
                <div>
                    <p style={{ marginLeft: 20 }}>
                        {getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.${restorativeOptions.subValue.value}`)}
                    </p>
                    {restorativeOptions.subValue.onlayPosition.length > 0 && (
                        <TeethDisplaySummary teeth={teeth} toothSelection={restorativeOptions.subValue.onlayPosition} />
                    )}
                    <div>{getLang('@NewPatient.prescriptionNotes.verticalDimensionQuestion')}</div>
                    <p style={{ marginLeft: 20 }}>
                        {getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.upperPosterior`)}:
                        <span style={{ marginLeft: 8 }}>{getValueDisplay(verticalDimensionUpperPosterior)}</span>
                    </p>
                    <p style={{ marginLeft: 20 }}>
                        {getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.lowerPosterior`)}:
                        <span style={{ marginLeft: 8 }}>{getValueDisplay(verticalDimensionLowerPosterior)}</span>
                    </p>
                </div>
            )}
        </>
    );
}
export default RestorativeOptionsSummary;
